var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RelationQueryBuilder } from '../builders/relationQueryBuilder';
import { HttpMethod } from '../enums/httpMethod';
export class HasMany extends RelationQueryBuilder {
    associate(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/associate`, HttpMethod.POST, this.prepareQueryParams(), {
                related_key: key,
            });
            return this.hydrate(response.data.data, response);
        });
    }
    dissociate(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpClient.request(`/${key}/dissociate`, HttpMethod.DELETE, this.prepareQueryParams());
            return this.hydrate(response.data.data, response);
        });
    }
}
//# sourceMappingURL=hasMany.js.map